



































import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import UserEdit from "@/components/userEdit.vue";
import PaginateModel from "@/model/paginate";
import User from "@/model/user";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import _cloneDeep from "lodash/cloneDeep";

const userStore = namespace("User");

@Component({
  name: "UserList",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    UserEdit,
  },
})
export default class UserList extends Vue {
  created() {
    this.$root.$on("fetchUserList", (query) => {
      this.fetchUserList(query);
    });
  }
  beforeDestroy() {
    this.$root.$off("fetchUserList");
  }

  @userStore.Getter
  public getUsers!: () => User[];

  @userStore.Getter
  public getPaginate!: () => PaginateModel[];

  @userStore.Action
  fetchUserList!: (parameters) => void;

  public editData = {};

  public headers = [
    { id: "id", name: "No", order: "desc", class: "mb__w70 mb__order" },
    { id: "name", name: "ユーザー名" },
    { id: "username", name: "ログインID" },
    { name: "", class: "mb__w60" },
  ];

  public noData = false;

  async doSearch(query: any) {
    const queryString = query.q ?? "";

    await this.fetchUserList({
      ...query,
      q: queryString.trim(),
    });

    this.noData = this.getUsers.length === 0 ? true : false;
  }

  public setEditData(user): void {
    (this.$refs.userEdit as UserEdit).clearErrors();
    this.editData = {};

    if (user.id) {
      this.editData = {
        ..._cloneDeep(user),
        password: "••••••••",
      };
    }
  }
}
